require(["jquery", "jszip", "antiForgeryTokenHelper"], function ($, JSZip, antiForgeryTokenHelper) {
    // Expose JSZip as a global
    window.JSZip = JSZip;

    // Session Timeout.
    $(document).ajaxError(function (xhr, props) {
        if (props.status === 499) {
            location.reload(true);
        }
    });

    var isAuthenticated = $('#hiddenUserIdentityIsAuthenticated').val() == 'True';
    if (isAuthenticated) {
        var baseUrl = $("#baseUrl").attr("data-url");

        $.ajax({
            url: baseUrl + 'api/UserProfile/Lastlogin',
            type: 'GET',
            headers: {
                'RequestVerificationToken': antiForgeryTokenHelper.getAntiForgeryToken(),
                'Access-Control-Allow-Origin': new URL(window.location.href).origin
            },
            success: function (data) {
                if (typeof data != 'undefined' && data) {
                    $("#iaccess_lastLogin").html("Last Login: " + data);
                }
            }
        });
    }

});